<app-core-header></app-core-header>
<router-outlet></router-outlet>
<app-core-footer></app-core-footer>